import { DataBean } from "../DataBean";

export class Egress extends DataBean {


    public async createCashReimbursementEgress(idCashReimbursement:any,cashReimbursementDate:any,idBankingAccount:any,observations:any,accountantDate:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.AccountantDocument_createCashReimbursementEgress_Number_java.util.Date_Number_String_java.util.Date_Number", [idCashReimbursement,cashReimbursementDate,idBankingAccount,observations,accountantDate,idEmployee]);
    }

}